var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs nav-tabs-element nav-tabs-bottom border-bottom-0 mb-0 w-100"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }